import z from "zod";
import type { FormInputSchemaParams } from "@/lib/types/form/form-field";

export default function rangeSliderZodSchema({ required, mode, min, max }: FormInputSchemaParams) {
	const minValue = typeof min === "number" ? min : undefined;
	const maxValue = typeof max === "number" ? max : undefined;
	const isRange = mode === "range";

	let numberSchema = z.number({ message: "invalidNumber" });
	if (minValue !== undefined) {
		numberSchema = numberSchema.min(minValue, { message: "rangeBelowMin" });
	}
	if (maxValue !== undefined) {
		numberSchema = numberSchema.max(maxValue, { message: "rangeAboveMax" });
	}

	return z.any().superRefine((value, ctx) => {
		if (value === null || value === undefined) {
			if (required) {
				ctx.addIssue({ code: "custom", message: "required" });
			}
			return;
		}

		if (isRange) {
			const tupleSchema = z
				.tuple([numberSchema, numberSchema])
				.refine(([rangeMin, rangeMax]) => rangeMin <= rangeMax, { message: "invalidRangeOrder" });
			const result = tupleSchema.safeParse(value);
			if (!result.success) {
				ctx.addIssue({ code: "custom", message: result.error.issues[0]?.message ?? "invalidRange" });
			}
			return;
		}

		const result = numberSchema.safeParse(value);
		if (!result.success) {
			ctx.addIssue({ code: "custom", message: result.error.issues[0]?.message ?? "invalidNumber" });
		}
	});
}
